var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysicalAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4H16V6H18V4Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8H16V10H18V8Z",
    fill: "#3B82F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H16V14H18V12Z",
    fill: "#3B82F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8V18H6V13H8V18H14V8L7 3L0 8ZM12 16H10V11H4V16H2V9L7 5.5L12 9V16Z",
    fill: "#3B82F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0V1.97L11 3.4V2H20V16H16V18H22V0H9Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalAdd);
export default __webpack_public_path__ + "static/media/physical_add.86e9e8dbc3f7292d110714d3528eb93d.svg";
export { ForwardRef as ReactComponent };